import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CommentsIcon } from '@/assets/icons/gallery-menu-comments.svg';
import { ReactComponent as TasksIcon } from '@/assets/icons/gallery-menu-tasks.svg';
import { ReactComponent as VersionsIcon } from '@/assets/icons/gallery-menu-versions.svg';
import { Button, Container, Label } from '@/features/media/ui/FileManager/Menu.styles';

interface Props {
  contentType: 'comments' | 'tasks' | 'versions' | 'info' | undefined;
  setContentType: Dispatch<SetStateAction<'comments' | 'tasks' | 'versions' | 'info' | undefined>>;
  setCommentsThreadId: Dispatch<SetStateAction<string | undefined>>;
}

const Menu: FC<Props> = ({ contentType, setContentType, setCommentsThreadId }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Button active={contentType === 'tasks'} onClick={() => setContentType('tasks')}>
        <TasksIcon />
        <Label>{t('tasks')}</Label>
      </Button>

      <Button
        active={contentType === 'comments'}
        onClick={() => {
          setContentType('comments');
          setCommentsThreadId(undefined);
        }}
      >
        <CommentsIcon />

        <Label>{t('comments')}</Label>
      </Button>

      <Button active={contentType === 'versions'} onClick={() => setContentType('versions')}>
        <VersionsIcon />

        <Label>{t('versions')}</Label>
      </Button>

      {/*<Button active={contentType === 'info'} onClick={() => setContentType('info')}>*/}
      {/*  <InfoIcon />*/}

      {/*  <Label>{t('info')}</Label>*/}
      {/*</Button>*/}
    </Container>
  );
};

export default Menu;
